
export class PDF {

    constructor(_base64: string) {
        this.base64 = _base64;
    }

    base64: string;
}